import axios from 'axios';

export async function getHostsStripeStatus() {
  const { data } = await axios.get('/api/admin/hosts/stripe-status');
  return data;
}

export async function resendOnboarding(hostId) {
  const { data } = await axios.post(
    `/api/admin/hosts/${hostId}/resend-onboarding`,
  );
  return data;
}

export async function detachStripeAccount(hostId) {
  const { data } = await axios.post(
    `/api/admin/hosts/${hostId}/detach-stripe-account`,
  );
  return data;
}

export async function getTransactions(params = {}) {
  const { data } = await axios.get('/api/admin/stripe/transactions', {
    params,
  });
  return data;
}

export async function getStripeConfig() {
  const { data } = await axios.get('/api/admin/stripe/config');
  return data;
}

export async function updateStripeConfig(config) {
  const { data } = await axios.post('/api/admin/stripe/config', config);
  return data;
}

export async function getCommissionSettings() {
  const { data } = await axios.get('/api/admin/stripe/commission');
  return data;
}

export async function updateCommissionSettings(settings) {
  const { data } = await axios.post('/api/admin/stripe/commission', settings);
  return data;
}

export async function syncInvoiceStatuses() {
  const { data } = await axios.post('/api/admin/stripe/sync-statuses');
  return data;
}
